var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 164,
    viewBox: "0 0 176 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 149.193L78.2584 84.796",
    stroke: "url(#paint0_linear_652_48640)",
    strokeWidth: 29,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7603 125.491L110.03 101.893",
    stroke: "url(#paint1_linear_652_48640)",
    strokeWidth: 29,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3491 68.3935L74.3007 83.3069L73.0906 85.1845L51.0353 71.4517C49.9912 70.8017 49.6828 69.4273 50.3491 68.3935Z",
    fill: "url(#paint2_linear_652_48640)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9637 115.827L85.5147 93.3419L110.184 88.1387L81.9637 115.827Z",
    fill: "#F6AD20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7181 83.6596L78.3248 112.863C78.3265 113.444 78.5118 114.011 78.8547 114.483C79.1977 114.954 79.6808 115.307 80.2361 115.491C80.7914 115.675 81.3907 115.681 81.9495 115.508C82.5083 115.335 82.9985 114.992 83.3507 114.527L92.0905 95.5115L96.4638 93.2834L143.817 26.7112L144.698 21.5332L137.004 25.7623L72.7024 81.265L72.7181 83.6596Z",
    fill: "url(#paint3_linear_652_48640)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.829 21.0898C141.703 21.1385 52.0427 65.8994 51.9208 65.96C51.4763 66.1819 51.0995 66.5177 50.8291 66.9328C50.5587 67.3478 50.4045 67.8271 50.3826 68.3211C50.3607 68.8152 50.4717 69.3061 50.7042 69.7433C50.9368 70.1804 51.2824 70.5479 51.7055 70.8079L72.717 83.6674L144.696 21.541C144.311 21.2024 143.837 20.9802 143.329 20.9002C142.821 20.8203 142.301 20.8861 141.829 21.0898Z",
    fill: "url(#paint4_linear_652_48640)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.835 115.261L92.9755 94.5296L91.8137 96.4371L123.769 116.002C124.818 116.645 126.195 116.312 126.835 115.261Z",
    fill: "url(#paint5_linear_652_48640)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.793 21.6716C144.753 21.6325 144.74 21.572 144.697 21.5352L144.151 22.3052L92.0902 95.512L124.31 115.227C124.696 115.463 125.134 115.602 125.585 115.632C126.037 115.662 126.49 115.583 126.904 115.401C127.318 115.218 127.681 114.939 127.962 114.586C128.243 114.233 128.434 113.818 128.518 113.375L145.648 24.1572C145.724 23.7049 145.686 23.2409 145.537 22.8069C145.388 22.373 145.132 21.9828 144.793 21.6716Z",
    fill: "url(#paint6_linear_652_48640)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6166 96.129L144.946 23.0977",
    stroke: "url(#paint7_linear_652_48640)",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_652_48640",
    x1: 105.767,
    y1: 42.9813,
    x2: 38.5996,
    y2: 131.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_652_48640",
    x1: 114.553,
    y1: 87.7656,
    x2: 81.4972,
    y2: 125.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7736,
    stopColor: "#E7EFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_652_48640",
    x1: 42.3427,
    y1: 58.2198,
    x2: 74.1324,
    y2: 87.9474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB13D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_652_48640",
    x1: 105.138,
    y1: 115.641,
    x2: 108.649,
    y2: 21.6097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAAA34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_652_48640",
    x1: 97.538,
    y1: 20.8672,
    x2: 97.538,
    y2: 83.6674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC836"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_652_48640",
    x1: 143.818,
    y1: 120.494,
    x2: 86.0151,
    y2: 102.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB13D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_652_48640",
    x1: 118.888,
    y1: 21.5352,
    x2: 118.888,
    y2: 115.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_652_48640",
    x1: 137.844,
    y1: 18.0802,
    x2: 104.731,
    y2: 116.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE083",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendImg);
export default __webpack_public_path__ + "static/media/send-img.cbacff2842cc06691b421b4843f7d40a.svg";
export { ForwardRef as ReactComponent };